export const USER_UPDATE = 'USER_UPDATE';

export const updateUserState = user => ({
  type: USER_UPDATE,
  user,
});
